export class AircraftType {
	id: number;
	iata: string;
	icao: string;
	name: string[];
}
